import type { BlogTag } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page/types';
import type { PostPageRenderModel } from '../../external/blocks-widget/post-page-render-model';
import model from './model';

type RepeaterItemSelector = (selector: string) => { link: string; label: string; target: string };

interface RepeaterItem {
  _id: string;
  label: string;
  link: string;
}

const selectors = {
  tags: '#tagsElement',
  tagsRoot: '#tagsRoot',
  tagsRepeaterElement: '#category',
} as const;

export default model.createController(({ $w }) => {
  const components = {
    tags: $w(selectors.tags),
    tagsRoot: $w(selectors.tagsRoot),
  };

  const setTags = (tags: BlogTag[]) => {
    if (tags.length) {
      components.tags.data = tags.map((tag) => ({
        _id: tag.id ?? '',
        label: tag.label ?? '',
        link: tag.url?.base! + tag.url?.path!,
      }));
      components.tags.forEachItem(($item: RepeaterItemSelector, itemData: RepeaterItem) => {
        $item(selectors.tagsRepeaterElement).label = itemData.label;
        $item(selectors.tagsRepeaterElement).link = itemData.link;
        $item(selectors.tagsRepeaterElement).target = '_self';
      });
    } else {
      // @ts-expect-error
      components.tagsRoot.delete();
    }
  };

  return {
    pageReady: async () => {},
    exports: {
      initialize: (renderModel: PostPageRenderModel) => {
        setTags(renderModel.tags);
      },
    },
  };
});
